import { Picker, type PickerOption } from './picker'

export type SearchableSelectOption = PickerOption

/** A compact searchable single-value picker. Options stay in caller order, so likely/recent choices can lead. */
export function SearchableSelect({
  value,
  onChange,
  options,
  ariaLabel,
  placeholder = 'Search or pick…',
  disabled = false,
  className,
}: {
  value: string
  onChange: (value: string) => void
  options: SearchableSelectOption[]
  ariaLabel: string
  placeholder?: string
  disabled?: boolean
  className?: string
}) {
  return (
    <Picker
      ariaLabel={ariaLabel}
      value={value}
      onValueChange={onChange}
      options={options}
      placeholder={placeholder}
      disabled={disabled}
      className={className}
    />
  )
}
